export const searchTypes = {
    getSearch: '[SEARCH] Get search',
    // searchNoContactable: '[SEARCH] No contactable',
    searchContactable: '[SEARCH] Contactable',
    setSearch: '[SEARCH] set search variables',
    resetSearch: '[SEARCH] Reset',
    resetPager: '[SEARCH] Reset pager',
}